<template>
    <div class="group">
        <div v-if="optionGroupName" class="name">{{ optionGroupName }}</div>
        <div class="entries">
            <OptionGroupOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :orderItem="option"
                :isParentItemCancelled="isParentItemCancelled"
                :displayPrice="displayPrice"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IOrderOptionGroup } from "@/data/model/Order";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import OptionGroupOption from "@/operator/components/order/OptionGroupOption.vue";

    const props = defineProps<{
        optionGroup: IOrderOptionGroup;
        isParentItemCancelled: boolean;
        displayPrice: boolean;
    }>();

    const optionGroupName = computed(() => {
        if (props.optionGroup.displayName === false) {
            return null;
        }

        return getNameInLocationLanguage(props.optionGroup, true);
    });
</script>
